import {
    GET_METER_SLABS,
    GET_METER_SLABS_SUCCESS,
    GET_METER_SLABS_FAILURE,
    GET_METER_SLABS_BY_HEAD,
    GET_METER_SLABS_BY_HEAD_SUCCESS,
    GET_METER_SLABS_BY_HEAD_FAILURE,
    GET_METER_SLAB_DETAILS,
    GET_METER_SLAB_DETAILS_SUCCESS,
    GET_METER_SLAB_DETAILS_FAILURE,
    CREATE_METER_SLAB,
    CREATE_METER_SLAB_SUCCESS,
    CREATE_METER_SLAB_FAILURE,
    CREATE_BULK_METER_SLABS,
    CREATE_BULK_METER_SLABS_SUCCESS,
    CREATE_BULK_METER_SLABS_FAILURE,
    UPDATE_METER_SLAB,
    UPDATE_METER_SLAB_SUCCESS,
    UPDATE_METER_SLAB_FAILURE,
    UPDATE_METER_SLAB_STATUS,
    UPDATE_METER_SLAB_STATUS_SUCCESS,
    UPDATE_METER_SLAB_STATUS_FAILURE,
    DELETE_METER_SLAB,
    DELETE_METER_SLAB_SUCCESS,
    DELETE_METER_SLAB_FAILURE,
    CLEAR_METER_SLAB_STATE
} from '../../../actions/index.types';

const initialState = {
    // List
    meterSlabsData: [],
    loading: false,
    error: null,

    // Details
    meterSlabDetails: null,
    detailsLoading: false,
    detailsError: null,

    // Create
    createLoading: false,
    createError: null,
    createSuccess: false,

    // Bulk Create
    bulkCreateLoading: false,
    bulkCreateError: null,
    bulkCreateSuccess: false,
    bulkCreateResult: null,

    // Update
    updateLoading: false,
    updateError: null,
    updateSuccess: false,

    // Status Update
    statusLoading: false,
    statusError: null,
    statusSuccess: false,

    // Delete
    deleteLoading: false,
    deleteError: null,
    deleteSuccess: false
};

const MeterSlabReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get All Meter Slabs
        case GET_METER_SLABS:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_METER_SLABS_SUCCESS:
            return {
                ...state,
                loading: false,
                meterSlabsData: action.data?.data || action.data || [],
                error: null
            };
        case GET_METER_SLABS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.data
            };

        // Get Meter Slabs by Head
        case GET_METER_SLABS_BY_HEAD:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_METER_SLABS_BY_HEAD_SUCCESS:
            return {
                ...state,
                loading: false,
                meterSlabsData: action.data?.data || action.data || [],
                error: null
            };
        case GET_METER_SLABS_BY_HEAD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.data
            };

        // Get Meter Slab Details
        case GET_METER_SLAB_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                detailsError: null
            };
        case GET_METER_SLAB_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                meterSlabDetails: action.data,
                detailsError: null
            };
        case GET_METER_SLAB_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                detailsError: action.data
            };

        // Create Meter Slab
        case CREATE_METER_SLAB:
            return {
                ...state,
                createLoading: true,
                createError: null,
                createSuccess: false
            };
        case CREATE_METER_SLAB_SUCCESS:
            return {
                ...state,
                createLoading: false,
                createSuccess: true,
                createError: null
            };
        case CREATE_METER_SLAB_FAILURE:
            return {
                ...state,
                createLoading: false,
                createError: action.data,
                createSuccess: false
            };

        // Bulk Create Meter Slabs
        case CREATE_BULK_METER_SLABS:
            return {
                ...state,
                bulkCreateLoading: true,
                bulkCreateError: null,
                bulkCreateSuccess: false,
                bulkCreateResult: null
            };
        case CREATE_BULK_METER_SLABS_SUCCESS:
            return {
                ...state,
                bulkCreateLoading: false,
                bulkCreateSuccess: true,
                bulkCreateResult: action.data,
                bulkCreateError: null
            };
        case CREATE_BULK_METER_SLABS_FAILURE:
            return {
                ...state,
                bulkCreateLoading: false,
                bulkCreateError: action.data,
                bulkCreateSuccess: false
            };

        // Update Meter Slab
        case UPDATE_METER_SLAB:
            return {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: false
            };
        case UPDATE_METER_SLAB_SUCCESS:
            return {
                ...state,
                updateLoading: false,
                updateSuccess: true,
                updateError: null
            };
        case UPDATE_METER_SLAB_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action.data,
                updateSuccess: false
            };

        // Update Meter Slab Status
        case UPDATE_METER_SLAB_STATUS:
            return {
                ...state,
                statusLoading: true,
                statusError: null,
                statusSuccess: false
            };
        case UPDATE_METER_SLAB_STATUS_SUCCESS:
            return {
                ...state,
                statusLoading: false,
                statusSuccess: true,
                statusError: null
            };
        case UPDATE_METER_SLAB_STATUS_FAILURE:
            return {
                ...state,
                statusLoading: false,
                statusError: action.data,
                statusSuccess: false
            };

        // Delete Meter Slab
        case DELETE_METER_SLAB:
            return {
                ...state,
                deleteLoading: true,
                deleteError: null,
                deleteSuccess: false
            };
        case DELETE_METER_SLAB_SUCCESS:
            return {
                ...state,
                deleteLoading: false,
                deleteSuccess: true,
                deleteError: null
            };
        case DELETE_METER_SLAB_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                deleteError: action.data,
                deleteSuccess: false
            };

        // Clear State
        case CLEAR_METER_SLAB_STATE:
            return initialState;

        default:
            return state;
    }
};

export default MeterSlabReducer;
